import { alpha, Stack, Typography, useTheme } from "@mui/material";
import type { FC, RefObject } from "react";
import type { DashboardType } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { EvaluationChip } from "web_myplann/Dashboard/Components/EvaluationChip";
import { getDashboardLinearGradient } from "web_myplann/Dashboard/Utils/getDashboardGradient";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type Props = {
	heroRef: RefObject<HTMLDivElement | null>;
	dashboard: DashboardType;
};

export const DashboardDetailHeader: FC<Props> = ({ heroRef, dashboard }) => {
	const { t } = useResource();
	const { palette } = useTheme();

	const currencySign =
		t(
			Resources.PortfolioDetail.SharedLabels.Currency[
				dashboard.currency as CurrencyEnum
			],
		) ?? t(Resources.Common.CurrencySign);

	return (
		<Stack
			ref={heroRef}
			alignItems="center"
			px={1.6}
			pt={6.4}
			pb={2.4}
			sx={{
				background: getDashboardLinearGradient(
					dashboard.gradientFrom,
					dashboard.gradientTo,
				),
			}}
		>
			<Typography
				variant="bodyMedium"
				color={alpha(palette.darkmodeText.white, 0.8)}
				mb={0.4}
			>
				{dashboard.type}
			</Typography>
			<Typography
				fontSize={32}
				fontWeight={700}
				color={palette.darkmodeText.white}
				tabular
				mb={1.2}
			>
				{moneyFormatter(
					Math.round(dashboard.value ?? 0),
					currencySign,
					`0 ${currencySign}`,
				)}
			</Typography>
			{dashboard.evaluation != null && (
				<EvaluationChip evaluation={dashboard.evaluation} />
			)}
		</Stack>
	);
};
